import {NgModule} from '@angular/core';
import {BrowserModule} from '@angular/platform-browser';
import {FormsModule} from '@angular/forms';
import {RouterModule} from '@angular/router';

import {AngularMultiSelectModule} from '../../angular2-multiselect-dropdown/multiselect.component';
import {DatetimeModule} from '../../datetime/datetime.module';

import {ResidentCreateComponent} from './resident-create/resident-create.component';
import {UnitCreateComponent} from './unit-create/unit-create.component';
import {ParkingSpotCreateComponent} from './parking-spot-create/parking-spot-create.component';
import {LockerCreateComponent} from './locker-create/locker-create.component';
import {VehicleCreateComponent} from './vehicle-create/vehicle-create.component';
import {PetCreateComponent} from './pet-create/pet-create.component';
import {BikeRackCreateComponent} from './bike-rack-create/bike-rack-create.component';
import {CommonComponentsModule} from '../../../common-components.module';
import {AngularMaterialImportModule} from '../../angular-material-import-module/angular-material-import.module';
import {FieldsModule} from '../../fields/fields.module';
import {VendorCreateModalComponent} from './vendor-create-modal/vendor-create-modal.component';
import {ScrollDispatchModule} from '@angular/cdk/scrolling';
import {FilterByPropertyPipeModule} from '../../../pipes/filter-by-property-pipe/filter-by-property-pipe.module';
import {UtilsModule} from '../../../modules/utils/utils.module';

@NgModule({
    imports: [
        BrowserModule,
        FormsModule,
        RouterModule,
        AngularMultiSelectModule,
        DatetimeModule,
        CommonComponentsModule,
        AngularMaterialImportModule,
        FieldsModule,
        ScrollDispatchModule,
        FilterByPropertyPipeModule,
        UtilsModule
    ],
    declarations: [
        ResidentCreateComponent,
        UnitCreateComponent,
        ParkingSpotCreateComponent,
        LockerCreateComponent,
        VehicleCreateComponent,
        PetCreateComponent,
        BikeRackCreateComponent,
        VendorCreateModalComponent
    ],
    exports: [
        ResidentCreateComponent,
        UnitCreateComponent,
        ParkingSpotCreateComponent,
        LockerCreateComponent,
        VehicleCreateComponent,
        PetCreateComponent,
        BikeRackCreateComponent,
        VendorCreateModalComponent
    ],
    providers: [],
})
export class CreateModalModule {
}



// WEBPACK FOOTER //
// /app/src/app/components/directory/create-modal/create-modal.module.ts